import {BettingSvc} from '../services/betting.service';
import compact from 'lodash/compact';

/**
 * Normal bet validator
 * @module directives/future bet validator
 * @type {{update: (function(*, *))}}
 */

export const NormalBetValidator = {
    update(element, binding){

        if (/[\d\.]+/i.test(element.value)) {

            let newValue = element.value;
            let bettingSvc = BettingSvc.getBettingSvc();

            //check input value
            if(element.value > 80 || element.value < 1){
                
                let itemIndex = bettingSvc.ticket.input.indexOf(newValue);
                newValue = element.value.substring(0, element.value.length - 1);
                bettingSvc.ticket.input[itemIndex] = newValue;
            }

            element.value = newValue;
            binding.value = element.value;

            //set number of systems
            let numbers =  compact(bettingSvc.ticket.input);
            bettingSvc.currentNumberOfSystems = numbers.length;

        } else {

            let newValue = element.value.replace(/[a-zA-Z]+/ig, '');
            element.value = newValue;
            binding.value = element.value;
        }
    },
};


// WEBPACK FOOTER //
// normalbet_validator.js